import { render, staticRenderFns } from "./StarrySkyPopup.vue?vue&type=template&id=c61ed128&scoped=true"
import script from "./StarrySkyPopup.vue?vue&type=script&lang=js"
export * from "./StarrySkyPopup.vue?vue&type=script&lang=js"
import style0 from "./StarrySkyPopup.vue?vue&type=style&index=0&id=c61ed128&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61ed128",
  null
  
)

export default component.exports